"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var transitionGroup_1 = require("spry-react/Animation/transitionGroup");
var animation_1 = require("spry-react/Animation/animation");
var htmlUtils_1 = require("spry-react/utils/htmlUtils");
var positioning_1 = require("spry-react/utils/positioning");
var react_focus_lock_1 = require("react-focus-lock");
var FlyoutSizeMode;
(function (FlyoutSizeMode) {
    FlyoutSizeMode[FlyoutSizeMode["SizeToPositioningElement"] = 0] = "SizeToPositioningElement";
    FlyoutSizeMode[FlyoutSizeMode["SizeToContents"] = 1] = "SizeToContents";
    FlyoutSizeMode[FlyoutSizeMode["FullWidth"] = 2] = "FullWidth";
})(FlyoutSizeMode = exports.FlyoutSizeMode || (exports.FlyoutSizeMode = {}));
var FlyoutPositioningMode;
(function (FlyoutPositioningMode) {
    FlyoutPositioningMode[FlyoutPositioningMode["BottomLeft"] = 0] = "BottomLeft";
    FlyoutPositioningMode[FlyoutPositioningMode["BottomRight"] = 1] = "BottomRight";
})(FlyoutPositioningMode = exports.FlyoutPositioningMode || (exports.FlyoutPositioningMode = {}));
var Flyout = /** @class */ (function (_super) {
    __extends(Flyout, _super);
    function Flyout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFlyoutWillEnter = function (flyout) {
            return { visibility: "hidden" };
        };
        _this.onFlyoutDidEnter = function (flyout, element) {
            return flyout.suppressAnimation
                ? { position: "relative", top: 0, height: 'auto' }
                : { position: "relative", top: new animation_1.DurationAnimationDefinition((-1 * element.clientHeight), 0, 150, animation_1.Easing.QuadIn), height: element.clientHeight };
        };
        _this.onFlyoutWillExit = function (flyout, element) {
            return flyout.suppressAnimation
                ? { position: "relative", top: -1 * element.clientHeight, height: element.clientHeight }
                : { position: "relative", top: new animation_1.DurationAnimationDefinition(0, (-1 * element.clientHeight), 150, animation_1.Easing.QuadOut), height: element.clientHeight };
        };
        _this.onFlyoutDoneEntering = function (flyout, element) {
            return { position: "relative", top: 0, height: 'auto' };
        };
        _this.renderFlyout = function (flyout, currentStyle, childRef) {
            var visibleContentHeight = currentStyle.height === 'auto'
                ? 'auto'
                : currentStyle.height + currentStyle.top + "px";
            return flyout.contents
                ? React.createElement(FlyoutContent, { positioningElementId: flyout.positioningElementId, sizeMode: flyout.sizeMode, positioningMode: flyout.positioningMode, fixed: flyout.fixed, flyoutClassName: flyout.flyoutClassName, key: flyout.key, height: visibleContentHeight, disableFocusLock: _this.props.disableFocusLock },
                    React.createElement("div", { style: __assign({}, currentStyle), ref: function (node) { childRef(node); _this.flyoutElement = node; } }, flyout.contents))
                : null;
        };
        _this.onFlyoutLogicalTreeClick = function (e) {
            _this.lastNativeClickEventInLogicalTree = e.nativeEvent;
        };
        _this.onMouseDown = function (event) {
            if (_this.lastNativeClickEventInLogicalTree === event) {
                _this.lastNativeClickEventInLogicalTree = null;
                return;
            }
            _this.lastNativeClickEventInLogicalTree = null;
            if (_this.flyoutElement && !htmlUtils_1.contains(event.target, _this.flyoutElement)) {
                _this.props.onClickOutsideFlyout(event.target);
            }
        };
        return _this;
    }
    Flyout.prototype.render = function () {
        return React.createElement("div", { onClick: this.onFlyoutLogicalTreeClick, style: { display: "none" } },
            React.createElement(transitionGroup_1.TransitionGroup, { key: "flyouts", data: this.props.flyout ? [this.props.flyout] : [], willEnter: this.onFlyoutWillEnter, didEnter: this.onFlyoutDidEnter, willExit: this.onFlyoutWillExit, doneEntering: this.onFlyoutDoneEntering, renderChild: this.renderFlyout }));
    };
    Flyout.prototype.componentDidMount = function () {
        document.addEventListener("click", this.onMouseDown);
    };
    Flyout.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.onMouseDown);
    };
    return Flyout;
}(React.Component));
exports.Flyout = Flyout;
var FlyoutContent = /** @class */ (function (_super) {
    __extends(FlyoutContent, _super);
    function FlyoutContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onWindowResize = function (event) {
            var position = _this.sizeAndPositionFlyout();
            if (position)
                _this.setState({ top: position.top, left: position.left, width: position.width });
        };
        // starts hidden at 0, 0 (to prevent a scroll bar from appearing) until componentDidMount
        _this.state = {
            visibility: 'hidden',
            top: '0',
            left: '0'
        };
        return _this;
    }
    FlyoutContent.prototype.render = function () {
        var _this = this;
        var flyoutStyle = { height: this.props.height, overflow: "hidden" };
        if (this.props.fixed) {
            flyoutStyle["position"] = "fixed";
        }
        flyoutStyle["top"] = this.state.top;
        if (this.props.sizeMode === FlyoutSizeMode.FullWidth) {
            flyoutStyle["left"] = 0;
            flyoutStyle["right"] = 0;
        }
        else {
            flyoutStyle["left"] = this.state.left;
            if (this.state.width)
                flyoutStyle["width"] = this.state.width;
        }
        flyoutStyle["visibility"] = this.state.visibility;
        flyoutStyle["boxSizing"] = "border-box";
        var flyoutClasses = ("custom-content-flyout " + this.props.flyoutClassName).trim();
        var positioningElement = this.props.positioningElementId ? document.getElementById(this.props.positioningElementId) : null;
        var flyoutContents = React.createElement("div", { className: flyoutClasses, ref: function (node) { return _this.flyoutElement = node; }, style: flyoutStyle },
            React.createElement(react_focus_lock_1.default, { returnFocus: true, shards: positioningElement ? [positioningElement] : [], disabled: this.props.disableFocusLock }, this.props.children));
        var portalContainer = document.getElementById('flyout-container');
        if (portalContainer == null)
            throw new Error("Opening a flyout requires a portal container with id 'flyout-container', but none was found in the DOM");
        return ReactDOM.createPortal(flyoutContents, portalContainer);
    };
    FlyoutContent.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        if (this.flyoutElement) {
            this.flyoutElement.style.display = 'block'; // override the css display none
        }
        // now that the element is mounted we have accurate widths so we can size and posiiton it
        var position = this.sizeAndPositionFlyout();
        if (position)
            this.setState({ visibility: 'visible', top: position.top, left: position.left, width: position.width });
        else
            this.setState({ visibility: 'visible' });
    };
    FlyoutContent.prototype.componentDidUpdate = function () {
        var _a = this.state, top = _a.top, left = _a.left, width = _a.width;
        var position = this.sizeAndPositionFlyout();
        if (position && (position.top !== top || position.left !== left || position.width !== width))
            this.setState({ visibility: 'visible', top: position.top, left: position.left, width: position.width });
    };
    FlyoutContent.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    FlyoutContent.prototype.sizeAndPositionFlyout = function () {
        if (!this.props.positioningElementId) {
            return;
        }
        var positioningElement = document.getElementById(this.props.positioningElementId);
        if (!positioningElement || !this.flyoutElement) {
            return;
        }
        var positioningRect = positioningElement.getBoundingClientRect();
        var flyoutElementWidth = positioningRect.width + "px";
        if (this.props.sizeMode === FlyoutSizeMode.SizeToPositioningElement) {
            this.flyoutElement.style.width = flyoutElementWidth;
        }
        var position = positioning_1.getRelativePosition(this.flyoutElement, positioningElement, this.props.positioningMode == FlyoutPositioningMode.BottomLeft ? positioning_1.HorizontalAlignment.AlignLeftSides : positioning_1.HorizontalAlignment.AlignRightSides, positioning_1.VerticalAlignment.Below, this.props.fixed || false);
        switch (this.props.sizeMode) {
            case FlyoutSizeMode.SizeToPositioningElement:
                return {
                    top: position.top + "px",
                    left: positioningRect.left + "px",
                    width: flyoutElementWidth
                };
            case FlyoutSizeMode.SizeToContents:
                return {
                    top: position.top + "px",
                    left: position.left + "px"
                };
            case FlyoutSizeMode.FullWidth:
                return {
                    top: position.top + "px",
                    left: '0'
                };
            default:
                return;
        }
    };
    FlyoutContent.defaultProps = {
        sizeMode: FlyoutSizeMode.SizeToContents,
        positioningMode: FlyoutPositioningMode.BottomLeft
    };
    return FlyoutContent;
}(React.Component));
